import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import ChipEdit from 'ChipEdit';
import transform from 'chipDataTransform';
import auth from 'ThreeTerminal_base/auth';

/**
 * for this page
 */
import Header from '@ifeng-fe/container_channel/common/client/summer/components/pc/header';
import Footer from '@ifeng-fe/container_channel/common/client/summer/components/pc/footer';
import Content from './content';

import { loginAuthFunc } from '../utils/utils';

class Layout extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {};

    componentDidMount() {
        const {
            content: { isLoginAuth },
        } = this.props;

        if (isLoginAuth === 1) {
            loginAuthFunc();

            this.unBindLogin = auth.event.on(auth.EVENTNAMES.login, () => {
                loginAuthFunc();
            });

            this.unBindLogout = auth.event.on(auth.EVENTNAMES.logout, () => {
                loginAuthFunc();
            });
        }
    }

    componentWillUnmount() {
        this.unBindLogin();
        this.unBindLogout();
    }

    render() {
        const { content } = this.props;

        const { nav, footer, search, isLoginAuth, surveyData } = content;
        const contentData = {
            search,
            isLoginAuth,
            surveyData,
        };

        return surveyData && surveyData.surveyinfo && surveyData.surveyinfo.isactive === '1' ? (
            <div className={styles.layout}>
                <Header content={nav} />
                <Content content={contentData} />
                <ChipEdit transform={transform} />
                <Footer content={footer} />
            </div>
        ) : (
            <div className={styles.request_no}>抱歉，该调查不存在，感谢您的关注!</div>
        );
    }
}

export default Layout;
